export const VERSION = `${process.env.NEXT_PUBLIC_VERSION}`
export const RENDER_URL = `${process.env.RENDER_API}/v2/render`
export const PRICES_URL = `${process.env.PRICES_API}/prices`
export const BUY_URL = `${process.env.BUY_API}/complete`
export const PLAN_PATH = process.env.PLAN_PATH || `/planos-`
export const PAYG_PATH = process.env.PAYG_PATH || `/destaques`
export const IS_PRODUCTION = process.env.NODE_ENV === `production`
export const GANDALF_API_URL = process.env.GANDALF_API_URL || ``
export const ZAP_CHECKOUT_URL = process.env.ZAP_CHECKOUT_URL || ``
export const ZAP_ADQUIRIR_URL = process.env.ZAP_ADQUIRIR_URL || ``
export const VIVAREAL_ADQUIRIR_URL = process.env.VIVAREAL_ADQUIRIR_URL || ``
export const ZAP_WHATSAPP_SALES_NUMBER =
  process.env.ZAP_WHATSAPP_SALES_NUMBER || ``
export const GTM_ID_VR = `GTM-TWSJ9VM`
export const GTM_ID_OLX = `GTM-546N2JV`
export const GTM_ID_ZAP = `GTM-W662TWW`

export const RENDER_TIMEOUT = process.env.RENDER_TIMEOUT
  ? Number(process.env.RENDER_TIMEOUT)
  : 2000
export const RENDER_RETRIES = process.env.RENDER_RETRIES
  ? Number(process.env.RENDER_RETRIES)
  : 1

export const ENABLE_LURKER =
  process.env.ENABLE_LURKER?.toLowerCase()?.trim() === `true` ||
  process.env.ENABLE_LURKER === `1`

export const ENABLE_GOOGLE_OPTIMIZE =
  process.env.ENABLE_GOOGLE_OPTIMIZE?.toLowerCase()?.trim() === `true` ||
  process.env.ENABLE_GOOGLE_OPTIMIZE === `1`

export const ENABLE_GOOGLE_GTM =
  process.env.ENABLE_GOOGLE_GTM?.toLowerCase()?.trim() === `true` ||
  process.env.ENABLE_GOOGLE_GTM === `1`

export const ENABLE_WEB_VITALS =
  process.env.ENABLE_WEB_VITALS?.toLowerCase()?.trim() === `true` ||
  process.env.ENABLE_WEB_VITALS === `1`

export const ENABLE_MOUSEFLOW =
  process.env.ENABLE_MOUSEFLOW?.toLowerCase()?.trim() === `true` ||
  process.env.ENABLE_MOUSEFLOW === `1`

export const DEFAULT_REGION = process.env.DEFAULT_REGION || `150`

export const DD = {
  APP_ID: process.env.DD_APP_ID || ``,
  CLIENT_TOKEN: process.env.DD_CLIENT_TOKEN || ``,
  SITE: process.env.DD_SITE || `datadoghq.com`,
  SERVICE_NAME: process.env.DD_SERVICE || `pos-viewer`,
  ENV: process.env.DD_ENV || `preprod`,
  SESSION_SAMPLE_RATE: parseInt(process.env.DD_SESSION_SAMPLE_RATE || `10`),
  SESSION_REPLAY_SAMPLE_RATE: parseInt(
    process.env.DD_SESSION_REPLAY_SAMPLE_RATE || `10`
  ),
  TRACK_USER_INTERACTIONS: Boolean(
    process.env.DD_TRACK_USER_INTERACTIONS || true
  ),
  TRACK_RESOURCES: Boolean(process.env.DD_TRACK_RESOURCES || true),
  TRACK_LONG_TASKS: Boolean(process.env.DD_TRACK_LONG_TASKS || true),
  DEFAULT_PRIVACY_LEVEL:
    process.env.DD_DEFAULT_PRIVACY_LEVEL || `mask-user-input`,
  ALLOWED_TRACING_URLS:
    process.env.DD_ALLOWED_TRACING_URLS ||
    `https://pos.olx.com.br/buy,https://pos.olx.com.br/v2/buy,https://pos.olx.com.br/complete,http://posrender.paidproducts.preprod.olxbr.io`,
  CLOUD_COST_CENTER:
    process.env.DD_CLOUD_COST_CENTER || `306f3829-7faa-4d28-975a-5d6e923f15b2`,
}
